"use client"
import IdeaElement from "@/components/home/ideals/idea"
import ContentElement from "@/components/UI/ContentElement/ContentElement"
import Footer from "@/components/UI/footer/footer"
import Topbar from "@/components/UI/navbar/topbar"
import Image from "next/image";

import Container from "@/components/UI/Containers/Container"
import { useRouter } from "next/navigation"
import React from "react";
import {SEOUtil} from "@/utils/SEOUtil";
import SearchElementMulti from "@/components/UI/search/searchElementMulti";

const Doradztwo: React.FC = () => {
  const router = useRouter()
  return (
    <>
      <SEOUtil name="Doradztwo" url="/app/doradztwo" description="Wybierz za pomocą naszego narzędzia szkołę, która do ciebie pasuje." mainEntityOfPage page />
      <Topbar />
      <main>
        <div className="relative w-full h-screen max-sm:h-[50vh] mb-16">
          <Image
            src="/doradztwo/brama.webp"
            alt="Tło doradztwo"
            fill
            priority
            style={{objectFit: "cover", zIndex: 0}}
          />
          <section
            className='absolute inset-0 text-white5 flex flex-col justify-center items-center w-full h-full overflow-hidden bg-cover bg-no-repeat bg-center'
            style={{
              background: "linear-gradient(rgba(34, 34, 34, 0.6), rgba(34, 34, 34, 0.6))",
              zIndex: 1,
            }}>
            <Container className='flex flex-col items-center justify-center max-sm:flex-col gap-10 '>
              <h1 className='text-white16 font-black mb-12 text-[4.2rem] leading-[1.05] tracking-[-0.5px] fadeIn text-center'>
                  Wyszukaj swój region lub kilka regionów
              </h1>
              <form className='md:w-1/2  w-3/4'>
                <SearchElementMulti
                  apiUrl='districts'
                  placeholder="Wyszukaj region(y)"
                  onSelect={(elements: { id: string; name: string }[]): void => {
                      const ids = elements.map(elem => elem.id).join(',')
                      router.push(`/app/doradztwo/form?districtIds=${ids}`)
                  }}
                />
              </form>
            </Container>
          </section>
        </div>
        <ContentElement
          className='p-20'
          heading={"W jaki sposób działa nasz program?"}
          subheading={"Jak to działa?"}
          childrenClassName='container grid grid-cols-2 justify-center gap-32 items-center'>
          <IdeaElement
            src={"/doradztwo/szkolyniepubliczne-wybór.jpg"}
            alt={"Wybór yes or no"}
            icon={<span className='text-blue-700'>1.</span>}
            heading={"Zdecyduj o rodzaju szkoły"}
            text={
              "Na początku algorytm poprosi Cię o decyzję, czy uwzględniać również szkoły niepubliczne. Twoja odpowiedź pomoże nam precyzyjnie dobrać rekomendowane kierunki, aby jak najlepiej odpowiadały Twoim oczekiwaniom."
            }
            isBlack
          />
          <IdeaElement
            src={"/doradztwo/typ-szkoly.jpg"}
            alt={"Człowiek zastanawiający się nad drogą"}
            icon={<span className='text-blue-700'>2.</span>}
            heading={"Wybierz preferowany typ szkoły"}
            text={
              "Na tym etapie określasz, czy wolisz liceum, technikum, czy szkołę branżową I stopnia. Algorytm zaproponuje kierunki, które najlepiej odpowiadają Twoim preferencjom."
            }
            isBlack
            reverse
          />
          <IdeaElement
            src={"/doradztwo/zainteresowania.jpg"}
            alt={""}
            icon={<span className='text-blue-700'>3.</span>}
            heading={"Wybierz swoje zainteresowania"}
            text={
              "Następnie wybierzesz swoje zainteresowania, czy wolisz przedmioty ścisłe, humanistyczne, artystyczne, czy może techniczne? Na tej podstawie zawęzimy Twoje preferencje zawodowe do najbardziej odpowiednich profili szkół."
            }
            isBlack
          />
          <IdeaElement
            src={"/doradztwo/rozszerzenia.jpg"}
            alt={"Człowiek z książką"}
            icon={<span className='text-blue-700'>4.</span>}
            heading={"Wskaż przedmioty, które chcesz rozszerzać"}
            text={
              "W kolejnym kroku wybierzesz przedmioty, które chcesz rozszerzać, np. matematyka, biologia, historia. Nasz algorytm dobierze szkoły, które oferują te rozszerzenia i najlepiej pasują do Twoich ambicji."
            }
            isBlack
            reverse
          />
          <IdeaElement
            src={"/doradztwo/rekomendacja.jpg"}
            alt={"Człowiek otwierający wrota"}
            icon={<span className='text-blue-700'>5.</span>}
            heading={"Otrzymaj rekomendacje kierunków"}
            text={
              "Na podstawie wybranych preferencji, algorytm przedstawi Ci listę najbardziej dopasowanych profili i kierunków, co pozwoli Ci łatwo znaleźć szkołę, która najlepiej spełnia Twoje oczekiwania."
            }
            isBlack
          />
        </ContentElement>
      </main>
      <Footer />
    </>
  )
}

export default Doradztwo
